export const queryParamKeys = {
  brand: 'brand',
  brandIdFilter: 'brandId',
  countyIdFilter: 'countyId',
  buyerTypeIdFilter: 'buyerTypeId',
  taxClassIdFilter: 'taxClassId',
  showDiscountedFilter: 'discounted',
  priceRangeFilterMin: 'priceMin',
  priceRangeFilterMax: 'priceMax',
  sortId: 'sortId',
  skip: 'skip',
  take: 'take',
};
